import React from 'react';
import PropTypes from 'prop-types';
import translate from '../../../../../commonComponents/translate';

const RewardJourneyCertificateCard = props => {
  const { t } = props;

  return (
    <div className="reward-certificate-wrapper">
      <span>{t('reward.certificate')}</span>
      <div className="image-container">
        <img src="/images/rewards/certificate.svg" alt="certificate" />
      </div>
    </div>
  );
};

RewardJourneyCertificateCard.propTypes = {
  t: PropTypes.func.isRequired,
};

export default translate(RewardJourneyCertificateCard);
